import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MaterialModule } from "app/material.module";
import { SharedModule } from "app/shared/shared.module";
import { labEntryPanelComponent } from "./labentry-panel/labentry-panel.component";
import { LabEntryRoutingModule } from "./labentry-routing.module";
import { TestResultEntryComponent } from "./testresultentry/testresultentry.component";
import { DailyExpensesDetailsComponent } from "./daily-expenses-details/daily-expenses-details.component";
import { SampleCollectedComponent } from './sample-collected/sample-collected.component';
import { SampleRecevingComponent } from './sample-receving/sample-receving.component';
import { NgxBarcodeModule } from "ngx-barcode";

@NgModule({
  declarations: [
    labEntryPanelComponent,
    TestResultEntryComponent,
    DailyExpensesDetailsComponent,
    SampleCollectedComponent,
    SampleRecevingComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    MatFormFieldModule,
    LabEntryRoutingModule,
    NgxBarcodeModule,
  ],
})
export class LabEntryModule {}
